import { render, staticRenderFns } from "./NavalRepair.vue?vue&type=template&id=63818636&scoped=true&"
import script from "./NavalRepair.vue?vue&type=script&lang=js&"
export * from "./NavalRepair.vue?vue&type=script&lang=js&"
import style0 from "./NavalRepair.vue?vue&type=style&index=0&id=63818636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63818636",
  null
  
)

export default component.exports